import { DEVICE_WIDTHS } from '@amzn/carrierlogistics-commons/dist/constants/breakpoints';
import Column from '@amzn/meridian/column';
import React, { useEffect, useRef } from 'react';
import PrivacyNotice from '../components/PrivacyNotice';
import '../styles/index.css';

const PrivacyPage = () => {
  const pageRef = useRef(null);
  useEffect(() => {
    pageRef.current.scrollIntoView();
  }, []);
  return (
    <div
      ref={pageRef}
      style={{
        position: 'relative',
        backgroundColor: '#f3f3f3',
        height: '100%',
        overflow: 'auto',
      }}
    >
      <Column alignmentHorizontal="center">
        <Column
          maxWidth={DEVICE_WIDTHS.DESKTOP}
          type="outline"
          backgroundColor="white"
          spacingInset="large large large large"
        >
          <PrivacyNotice />
        </Column>
      </Column>
    </div>
  );
};
export default PrivacyPage;
